export default [
    {
        id: 1,
        title: 'Podcasts',
        cover: 'https://i.scdn.co/image/567158eb895ad26718a814345af0fc43ee785ec5',
        color: '#27856A'
    },
    {
        id: 2,
        title: 'Charts',
        cover: 'https://charts-images.scdn.co/assets/locale_en/regional/weekly/region_global_default.jpg',
        color: '#8D67AB'
    },
    
    
    {
        id: 3,
        title: 'New Releases',
        cover: 'https://i.scdn.co/image/ab67706f000000027ea4d505212b9de1f72c5112',
        color: '#E8115B'
    },
    {
        id: 4,
        title: 'Charts',
        cover: 'https://charts-images.scdn.co/assets/locale_en/regional/weekly/region_global_default.jpg',
        color: '#8D67AB'
    },
    {
        id: 5,
        title: 'Made For You',
        cover: 'https://t.scdn.co/images/ea364e99656e46a096ea1df50f581efe', 
        color: '#1E3264'
    },
    {
        id: 6,
        title: 'Discover',
        cover: 'https://t.scdn.co/images/d0fb2ab104dc4846bdc56d72b0b0d785.jpeg',
        color: '#8D67AB'
    },
    
    {
        id: 7,
        title: 'Made For You',
        cover: 'https://t.scdn.co/images/ea364e99656e46a096ea1df50f581efe', 
        color: '#1E3264'
    },
    
    {
        id: 8,
        title: 'Podcasts',
        cover: 'https://i.scdn.co/image/567158eb895ad26718a814345af0fc43ee785ec5',
        color: '#27856A'
    },
    {
        id: 9,
        title: 'New Releases',
        cover: 'https://i.scdn.co/image/ab67706f000000027ea4d505212b9de1f72c5112',
        color: '#E8115B'
    },
    {
        id: 10,
        title: 'Charts',
        cover: 'https://charts-images.scdn.co/assets/locale_en/regional/weekly/region_global_default.jpg',
        color: '#8D67AB'
    },
    {
        id: 11,
        title: 'New Releases',
        cover: 'https://i.scdn.co/image/ab67706f000000027ea4d505212b9de1f72c5112',
        color: '#E8115B'
    },
    {
        id: 12,
        title: 'Discover',
        cover: 'https://t.scdn.co/images/d0fb2ab104dc4846bdc56d72b0b0d785.jpeg',
        color: '#8D67AB'
    },
    {
        id: 13,
        title: 'Podcasts',
        cover: 'https://i.scdn.co/image/567158eb895ad26718a814345af0fc43ee785ec5',
        color: '#27856A'
    },
    {
        id: 14,
        title: 'Made For You',
        cover: 'https://t.scdn.co/images/ea364e99656e46a096ea1df50f581efe', 
        color: '#1E3264'
    },
    {
        id: 15,
        title: 'Charts',
        cover: 'https://charts-images.scdn.co/assets/locale_en/regional/weekly/region_global_default.jpg',
        color: '#8D67AB'
    },
    {
        id: 16,
        title: 'New Releases',
        cover: 'https://i.scdn.co/image/ab67706f000000027ea4d505212b9de1f72c5112',
        color: '#E8115B'
    },
    {
        id: 17,
        title: 'Discover',
        cover: 'https://t.scdn.co/images/d0fb2ab104dc4846bdc56d72b0b0d785.jpeg',
        color: '#8D67AB'
    },
    {
        id: 18,
        title: 'Podcasts',
        cover: 'https://i.scdn.co/image/567158eb895ad26718a814345af0fc43ee785ec5',
        color: '#27856A'
    },
    {
        id: 19,
        title: 'Made For You',
        cover: 'https://t.scdn.co/images/ea364e99656e46a096ea1df50f581efe', 
        color: '#1E3264'
    },
    {
        id: 20,
        title: 'Charts',
        cover: 'https://charts-images.scdn.co/assets/locale_en/regional/weekly/region_global_default.jpg',
        color: '#8D67AB'
    },
    {
        id: 21,
        title: 'Podcasts',
        cover: 'https://i.scdn.co/image/567158eb895ad26718a814345af0fc43ee785ec5',
        color: '#27856A'
    },
    {
        id: 22,
        title: 'Made For You',
        cover: 'https://t.scdn.co/images/ea364e99656e46a096ea1df50f581efe', 
        color: '#1E3264'
    },
    {
        id: 23,
        title: 'Charts',
        cover: 'https://charts-images.scdn.co/assets/locale_en/regional/weekly/region_global_default.jpg',
        color: '#8D67AB'
    },
    {
        id: 24,
        title: 'New Releases',
        cover: 'https://i.scdn.co/image/ab67706f000000027ea4d505212b9de1f72c5112',
        color: '#E8115B'
    },
    {
        id: 25,
        title: 'Discover',
        cover: 'https://t.scdn.co/images/d0fb2ab104dc4846bdc56d72b0b0d785.jpeg',
        color: '#8D67AB'
    },
    {
        id: 26,
        title: 'Charts',
        cover: 'https://charts-images.scdn.co/assets/locale_en/regional/weekly/region_global_default.jpg',
        color: '#8D67AB'
    },
    {
        id: 27,
        title: 'Podcasts',
        cover: 'https://i.scdn.co/image/567158eb895ad26718a814345af0fc43ee785ec5',
        color: '#27856A'
    },
    {
        id: 28,
        title: 'New Releases',
        cover: 'https://i.scdn.co/image/ab67706f000000027ea4d505212b9de1f72c5112',
        color: '#E8115B'
    },
    {
        id: 29,
        title: 'Discover',
        cover: 'https://t.scdn.co/images/d0fb2ab104dc4846bdc56d72b0b0d785.jpeg',
        color: '#8D67AB'
    },
    {
        id: 30,
        title: 'Podcasts',
        cover: 'https://i.scdn.co/image/567158eb895ad26718a814345af0fc43ee785ec5',
        color: '#27856A'
    }


]